import Carousel from '../../node_modules/bootstrap/js/dist/carousel'

export default function carouselable(node, params) {
  console.log('Initializing carousel for', node, params)
  const carousel = new Carousel(node, params)

  return {
    destroy() {
      carousel.dispose()
    },
  }
}
